import classes from "../ServicesTable.module.scss"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OutboxIcon from '@mui/icons-material/Outbox';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import LoginIcon from '@mui/icons-material/Login';
import StartIcon from '@mui/icons-material/Start';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useContext, useEffect, useState } from "react";
import { Container, Row , Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { TextField } from "../../integrationWizard/form/TextField";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Button from "../../UI/Button";
import { OrgIdContext } from "../../../store/orgId_context";
import EditOffIcon from '@mui/icons-material/EditOff';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CircleIcon from '@mui/icons-material/Circle';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import { t } from "i18next";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import DeviceForm from "./DeviceForm";

const DeviceTr = ({data, index, payments, orgData, info, onDataChanged:onDataChangedImported}) => {
    const [editable, setEditable] = useState();
    const [hasFields, setHasFields] = useState(false);
    const { isMaintainer } = useContext(OrgIdContext);

    const [showForm, setShowForm] = useState(false);

    const onTrClick = () =>{
        setShowForm(prev => !prev);
    }

    useEffect(() => {
        if(!data) return;

        setEditable(!data.AddByReg);
    },[data]);

//#endregion
    const getIconForDirection = (direction) =>{
        switch(direction){
            case "Recieve":
                return <MoveToInboxIcon className="main-blue"/>
            case "Send":
                return <OutboxIcon className="main-blue"/>
            case "Both":
                return <ImportExportIcon className="main-blue"/>
            case "PushREI":
                return <LoginIcon className="main-blue" style={{transform:"rotate(-90deg)"}}/>
            case "PushIEI":
                return <StartIcon className="main-blue" style={{transform:"rotate(-90deg)"}}/>
            case "Push":
                return <CloudUploadIcon className="main-blue"/>
            default:
                return <OutboxIcon className="main-blue"/>
        }
    }
    const getIconForType = (type) =>{
        switch(type){
            case "PublicSector":
                return <PublicIcon className="main-blue"/>
            case "PrivateSector":
                return <PublicOffIcon className="main-blue"/>
            case "All":
                return <AllInclusiveIcon className="main-blue"/>
            default:
                return <AllInclusiveIcon className="main-blue"/>
        }
    }

    const formatDateToDDMMYYYY = (date) => {
        try{
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(d.getDate()).padStart(2, '0');
            return `${day}/${month}/${year}`;
        }catch(e){
            return false;
        }
    }

    const onDataChanged = (newData) => {
        if(onDataChangedImported) onDataChangedImported(newData);
    }
    
    return (
    <>
        <Container fluid className={`${classes["rowContainer"]} g-0`} style={index%2===0 ? {backgroundColor:"#f1f5fd"} : {backgroundColor:"#f9fbff"}}>
            <Row  className={`${classes["tableRow"]} g-0`} onClick={onTrClick} style={{cursor:"pointer"}}>
                <Col className={`col-7 ${classes["trcol"]}`} style={{textAlign:"left", paddingLeft:"1rem", fontWeight:"bold"}}>
                    {data["ExternalName"]||data["InternalName"]||"Unknown"}
                    {(data["AssignedTo"] === "CKI" || data["AssignedTo"] === "CKT") && <><span style={{fontWeight:"normal", marginLeft:"0.5rem"}}>({data["Id"]})</span></>}
                </Col>
                <Col className={`col-1 ${classes["trcol"]}`}>
                    {data["AssignedTo"] === "CKI" &&
                        <OverlayTrigger placement="top" overlay={<Tooltip>{t("This is a TEST device only intended for testing your integration process. It can never be in production mode.")}</Tooltip>}>
                            <RemoveCircleIcon/>
                        </OverlayTrigger>}
                    {!(data["AssignedTo"] === "CKI") && 
                        <OverlayTrigger placement="top" overlay={<Tooltip>{data["Mode"]==="PROD" ? t("Device is in PRODUCTION mode") : t("Device is in TEST mode")}</Tooltip>}>
                            {/* <CheckCircleIcon style={data["Mode"]==="PROD" ? {color:"green"} : {}}/> */}
                            {data["Mode"]==="PROD" ? <CheckCircleIcon style={{color:"green"}}/> : <UnpublishedIcon/>}
                        </OverlayTrigger>}
                </Col>
                <Col className={`col-3 ${classes["trcol"]}`}>
                    {formatDateToDDMMYYYY(data["CreateDate"])||"\\"}
                </Col>
                <Col className={`col-1 ${classes["trcollast"]}`} style={{textAlign:"right", paddingRight:"1rem"}}>
                    {!editable && 
                        <OverlayTrigger placement="top" overlay={<Tooltip>{t("This is a default device")}</Tooltip>}>
                            <ContactSupportIcon className="main-blue"/>
                        </OverlayTrigger>
                    }
                </Col>
            </Row>
            {showForm &&
            <Row className={classes["formRow"]}>
                <Col>
                    <DeviceForm data={data} index={index} info={info} payments={payments} orgData={orgData} onDataChanged={onDataChanged}/>
                </Col>
            </Row>
            }
        </Container>
    </>
    )
}

export default DeviceTr;